import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="open-comment"
export default class extends Controller {
  open() {
    // 1) Switch to Reviews tab by clicking its tab button
    const reviewsTabButton = document.querySelector(
      '[data-tabs-target="tab"][data-tab-id="reviews"]'
    );
    if (reviewsTabButton) {
      reviewsTabButton.click();
    }

    // 2) After panel is visible, trigger the comment form to show
    setTimeout(() => {
      const commentFormButton = document.querySelector(
        '[data-controller~="comment-form"] [data-comment-form-target="button"] button'
      );
      if (commentFormButton) {
        commentFormButton.click();
      }
    }, 50);
  }
}
